module.exports = __webpack_public_path__ + "static/media/delete_stanby.9fb0ba2c.svg";